/* Join the Team single-page subscription form
 * ---------------------------------------------
 * Reads data-jtt-plans JSON, populates shirt/shorts dropdowns from the
 * selected plan's product (1st or 15th based on today's date), resolves
 * variant on submit, and POSTs to /cart/add.js -> redirects to /checkout.
 *
 * Recharge attachment happens at product level (the subscription products
 * already have subscription purchase options), so no selling_plan param
 * is required in the add-to-cart payload.
 */
(function () {
  'use strict';

  var form = document.querySelector('[data-jtt-form]');
  if (!form) return;

  var plansScript = document.querySelector('[data-jtt-plans]');
  if (!plansScript) {
    console.error('[JTT] Missing data-jtt-plans JSON script');
    return;
  }

  var data;
  try {
    data = JSON.parse(plansScript.textContent);
  } catch (e) {
    console.error('[JTT] Bad plans JSON', e);
    return;
  }

  var plans = (data && data.plans) || [];
  // Prefer server-rendered today_date; fall back to browser date if missing
  var todayDate = (data && typeof data.today_date === 'number') ? data.today_date : new Date().getDate();

  // --- elements ---
  var shirtSelect  = form.querySelector('[data-jtt-shirt]');
  var shortsSelect = form.querySelector('[data-jtt-shorts]');
  var planRadios   = form.querySelectorAll('input[name="plan_index"]');
  var variantInput = form.querySelector('[data-jtt-variant-id]');
  var handleInput  = form.querySelector('[data-jtt-handle]');
  var submitBtn    = form.querySelector('[data-jtt-submit]');
  var errorBox     = form.querySelector('[data-jtt-error]');

  // Ensure a hidden selling_plan input exists (required by Recharge-backed products)
  var sellingPlanInput = form.querySelector('[data-jtt-selling-plan]');
  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    sellingPlanInput.setAttribute('data-jtt-selling-plan', '');
    sellingPlanInput.value = '';
    variantInput.parentNode.insertBefore(sellingPlanInput, variantInput.nextSibling);
  }

  // --- helpers ---
  function getActiveProduct(plan) {
    if (!plan) return null;
    // If only one of 1st/15th is set, use that regardless of date
    if (plan.product_1st && !plan.product_15th) return plan.product_1st;
    if (!plan.product_1st && plan.product_15th) return plan.product_15th;
    return todayDate >= 15 ? plan.product_15th : plan.product_1st;
  }

  function uniq(arr) {
    var seen = Object.create(null);
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var v = arr[i];
      if (v == null) continue;
      // Strip Shopify's placeholder "default" / "Default Title" entries
      if (typeof v === 'string') {
        var lower = v.toLowerCase().trim();
        if (lower === 'default' || lower === 'default title') continue;
      }
      if (!seen[v]) { seen[v] = true; out.push(v); }
    }
    return out;
  }

  function repopulateSelect(selectEl, values, placeholder) {
    var current = selectEl.value;
    selectEl.innerHTML = '';
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder || 'Select…';
    selectEl.appendChild(opt);
    for (var i = 0; i < values.length; i++) {
      var o = document.createElement('option');
      o.value = values[i];
      o.textContent = values[i];
      if (values[i] === current) o.selected = true;
      selectEl.appendChild(o);
    }
    // Mirror to sibling button group, if present
    renderSizeButtons(selectEl, values);
  }

  function renderSizeButtons(selectEl, values) {
    var attr = selectEl.matches('[data-jtt-shirt]') ? 'data-jtt-shirt-btns'
             : selectEl.matches('[data-jtt-shorts]') ? 'data-jtt-shorts-btns'
             : null;
    if (!attr) return;
    var group = form.querySelector('[' + attr + ']');
    if (!group) return;
    group.innerHTML = '';
    var current = selectEl.value;
    for (var i = 0; i < values.length; i++) {
      var v = values[i];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jtt-size-btn';
      btn.setAttribute('data-size-val', v);
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', v === current ? 'true' : 'false');
      if (v === current) btn.classList.add('is-on');
      btn.textContent = v;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var val = this.getAttribute('data-size-val');
        selectEl.value = val;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        // Update visual state
        var sibs = group.querySelectorAll('.jtt-size-btn');
        for (var k = 0; k < sibs.length; k++) {
          var on = sibs[k].getAttribute('data-size-val') === val;
          sibs[k].classList.toggle('is-on', on);
          sibs[k].setAttribute('aria-checked', on ? 'true' : 'false');
        }
      });
      group.appendChild(btn);
    }
  }

  function getSelectedPlanIndex() {
    for (var i = 0; i < planRadios.length; i++) {
      if (planRadios[i].checked) return parseInt(planRadios[i].value, 10);
    }
    return -1;
  }

  function refreshSizeOptions() {
    var idx = getSelectedPlanIndex();
    var plan = plans[idx];
    var product = getActiveProduct(plan);
    if (!product || !product.variants) {
      repopulateSelect(shirtSelect, [], 'No sizes available');
      repopulateSelect(shortsSelect, [], 'No sizes available');
      return;
    }
    var shirtSizes  = uniq(product.variants.map(function (v) { return v.option1; }));
    var shortsSizes = uniq(product.variants.map(function (v) { return v.option2; }));
    repopulateSelect(shirtSelect, shirtSizes, 'Select shirt size');
    // If this product has no second option, hide shorts dropdown entirely
    if (shortsSizes.length === 0) {
      shortsSelect.parentElement.hidden = true;
      shortsSelect.required = false;
    } else {
      shortsSelect.parentElement.hidden = false;
      shortsSelect.required = true;
      repopulateSelect(shortsSelect, shortsSizes, 'Select shorts size');
    }
    handleInput.value = product.handle || '';
    resolveVariant(); // re-resolve since options changed
  }

  function resolveVariant() {
    var idx = getSelectedPlanIndex();
    var plan = plans[idx];
    var product = getActiveProduct(plan);
    if (!product) { variantInput.value = ''; return; }

    var shirtVal  = shirtSelect.value;
    var shortsVal = shortsSelect.value;

    var match = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var shirtOk  = !shirtVal || v.option1 === shirtVal;
      var shortsOk = !shortsVal || !v.option2 || v.option2 === shortsVal;
      if (shirtOk && shortsOk) { match = v; break; }
    }
    variantInput.value = (match && match.available) ? String(match.id) : '';
    sellingPlanInput.value = (match && match.selling_plan_id) ? String(match.selling_plan_id) : '';
  }

  function showError(msg) {
    if (!errorBox) return;
    errorBox.textContent = msg;
    errorBox.hidden = false;
  }

  function clearError() {
    if (!errorBox) return;
    errorBox.textContent = '';
    errorBox.hidden = true;
  }

  function validate() {
    clearError();
    var idx = getSelectedPlanIndex();
    if (idx < 0) { showError('Please pick a plan.'); return false; }

    var sport = form.querySelector('input[name="properties[Sport]"]:checked');
    if (!sport) { showError('Please select a sport.'); return false; }

    if (!shirtSelect.value) { showError('Please select a shirt size.'); return false; }

    if (!shortsSelect.parentElement.hidden && !shortsSelect.value) {
      showError('Please select a shorts size.'); return false;
    }

    var ageInput = form.querySelector('[name="properties[Age]"]');
    if (!ageInput || !ageInput.value) { showError('Please enter age.'); return false; }

    if (!variantInput.value) {
      showError('This size combination is not available. Try another.'); return false;
    }

    if (!sellingPlanInput.value) {
      showError('Subscription plan not available for this product. Please try another plan or contact support.'); return false;
    }

    return true;
  }

  // --- wire events ---
  for (var i = 0; i < planRadios.length; i++) {
    planRadios[i].addEventListener('change', refreshSizeOptions);
    planRadios[i].addEventListener('change', syncPlanTilesFromRadio);
  }
  shirtSelect.addEventListener('change', resolveVariant);
  shortsSelect.addEventListener('change', resolveVariant);

  // Plan-card tile clicks → check matching plan_index radio
  function syncPlanTilesFromRadio() {
    var checked = form.querySelector('input[name="plan_index"]:checked');
    var tiles = document.querySelectorAll('[data-jtt-plan-tile]');
    var val = checked ? checked.value : null;
    tiles.forEach(function(t) {
      var on = String(t.getAttribute('data-plan-index')) === String(val);
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function(e) {
    var tile = e.target.closest('[data-jtt-plan-tile]');
    if (!tile) return;
    e.preventDefault();
    var idx = tile.getAttribute('data-plan-index');
    var radio = form.querySelector('input[name="plan_index"][value="' + idx + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      // even if no change, still mirror state
      syncPlanTilesFromRadio();
    }
  });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();

    // ── Phase 1 ─────────────────────────────────────────────────────────────
    // First click: validate plan selection, then reveal the player-detail
    // fields. Return early — don't submit yet.
    var detailsWrap = form.querySelector('[data-jtt-details]');
    if (detailsWrap && !detailsWrap.classList.contains('is-revealed')) {
      if (getSelectedPlanIndex() < 0) {
        showError('Please pick a plan to continue.');
        return;
      }
      clearError();
      detailsWrap.classList.add('is-revealed');
      submitBtn.textContent = 'Add to Cart →';
      // Scroll the revealed fields into view after the animation starts
      setTimeout(function () {
        detailsWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 60);
      return; // ← stop here; user fills in details, then clicks again
    }
    // ── Phase 2 ─────────────────────────────────────────────────────────────

    if (!validate()) return;

    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Adding to cart…';

    var body = new FormData(form);
    // Strip fields that aren't part of the Shopify cart/add payload
    body.delete('plan_index');
    body.delete('shirt_size');
    body.delete('shorts_size');

    fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
      return res.json();
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      submitBtn.disabled = false;
      submitBtn.textContent = originalLabel;
      showError(err.message || 'Could not add to cart. Please try again.');
    });
  });

  // --- init ---
  refreshSizeOptions();
})();
